<section>

    <div class="p-5 card">

        <form [formGroup]="othersForm" (ngSubmit)="saveForm()">

            <ul class="grid grid-cols-1 gap-4">
                <li>
                    <label class="form-control w-full max-w-xs">
                        <div class="label">
                            <span class="label-text req">Select Faculty</span>
                        </div>
                        <select
                            [ngClass]="{'error': othersForm.get('faculty_id')?.invalid && othersForm.get('faculty_id')?.touched}"
                            class="select select-sm select-bordered" formControlName="faculty_id">
                            <option disabled selected>Choose Faculty</option>

                            @for (i of facultyList; track $index) {
                            <option value="{{i.id}}">{{i.name}}</option>
                            }

                        </select>
                        @if (othersForm.get('faculty_id')?.invalid && othersForm.get('faculty_id')?.touched) {
                        <span class="text-red-500 text-xs">Faculty is required</span>
                        }
                    </label>
                </li>

                <li>
                    <label class="form-control w-full max-w-xs">
                        <div class="label">
                            <span class="label-text req">Select Contributor</span>
                        </div>
                        <select
                            [ngClass]="{'error': othersForm.get('contributor_id')?.invalid && othersForm.get('contributor_id')?.touched}"
                            class="select select-sm select-bordered" formControlName="contributor_id">
                            <option disabled selected>Choose Contributor</option>
                            @for (i of usersList; track $index) {
                            <option value="{{i.id}}">{{i.name}}</option>
                            }
                        </select>
                        @if (othersForm.get('contributor_id')?.invalid && othersForm.get('contributor_id')?.touched) {
                        <span class="text-red-500 text-xs">Contributor is required</span>
                        }
                    </label>
                </li>

                <li>
                    <hr class="my-3">
                </li>
                <li
                    [ngClass]="{'error':othersForm.get('testimonial_id')?.value.length == 0 && othersForm.get('testimonial_id')?.touched}">
                    <div class="flex justify-between items-center">
                        <p class="font-semibold text-sm">Select Testimonial for display</p>
                        <button type="button" class="btn btn-sm "
                            (click)="showTestimonalAndCommentModal('testimonial')"><i class="ri-add-line"></i> Add
                            Testimonial</button>
                    </div>
                    @if (othersForm.get('testimonial_id')?.value.length == 0 &&
                    othersForm.get('testimonial_id')?.touched) {
                    <p class="text-sm text-red-500">No testimonials selected</p>
                    }
                    <ul class="mt-3 columns-2 gap-4 space-y-4">

                        @for (i of selectedTestimonal; track $index) {

                        <li class="break-inside-avoid">

                            <div class="border p-4 rounded-md block ">

                                <div class="flex gap-1 items-center">
                                    <div class="flex">
                                        <input type="checkbox" [value]="i.id" id="selected_testimonial_{{$index}}" hidden>
                                        <label for="selected_testimonial_{{$index}}"
                                            class="bg-amber-100 btn btn-sm  btn-circle text-amber-500">
                                            <i class="ri-star-fill"></i>
                                        </label>
                                        <label for="selected_testimonial_{{$index}}"
                                            class="bg-zinc-100 px-4 font-semibold rounded-full text-zinc-500 py-2 text-xs">
                                            <i class="ri-star-fill"></i> <span>Highlight</span>
                                        </label>
                                    </div>
                                    <button type="button" (click)="removetestimonalAndComment(i.id,'testimonial_id')"
                                        class="btn btn-sm bg-red-100 text-red-500 btn-circle"><i
                                            class="ri-delete-bin-line"></i></button>
                                </div>

                                <div class="flex items-center gap-3 my-2">
                                    <div class="avatar">
                                        <div class="w-8 h-8 rounded-full overflow-hidden">
                                            <img [src]="getTestimonialUserImage(i)" [alt]="getTestimonialUserName(i)" />
                                        </div>
                                    </div>
                                    <p class="font-semibold">{{getTestimonialUserName(i)}}</p>
                                </div>
                                <p class="text-sm text-zinc-600 break-all">
                                    {{i.testimonial}}
                                </p>
                            </div>


                            <!-- <input type="checkbox" [value]="i.id" id="testimonial_{{$index}}" hidden
                                class="card_highlight_checkBox" (change)="onCheckboxChange($event,'testimonial_id',i)"
                                [checked]="othersForm.get('testimonial_id')?.value.includes(i.id)" />
                            <label for="testimonial_{{$index}}" class="bg-zinc-100 p-4 rounded-md block cursor-pointer">
                                <div class="flex items-center gap-3 mb-2">
                                    <div class="avatar">
                                        <div class="w-8 h-8 rounded-full overflow-hidden">
                                            <img [src]="i.user_image" [alt]="i.user_name" />
                                        </div>
                                    </div>
                                    <p class="font-semibold">{{i.user_name}}</p>
                                </div>
                                <p class="text-sm text-zinc-600 break-all">
                                    {{i.testimonial}}
                                </p>
                            </label> -->
                        </li>
                        }



                    </ul>
                </li>
                <li>
                    <hr class="my-3">
                </li>

                <li
                    [ngClass]="{'error':othersForm.get('commented_id')?.value.length == 0 && othersForm.get('commented_id')?.touched}">
                    <div class="flex justify-between items-center">
                        <p class="font-semibold text-sm">Select Comments for display</p>
                        <button type="button" class="btn btn-sm " (click)="showTestimonalAndCommentModal('comment')"><i
                                class="ri-add-line"></i> Add
                            Comment</button>
                    </div>
                    @if (othersForm.get('commented_id')?.value.length == 0 && othersForm.get('commented_id')?.touched) {
                    <p class="text-sm text-red-500">No comments selected</p>
                    }
                    <ul class="mt-3 columns-2 gap-4 space-y-4">
                        @for (i of selectedComments; track $index) {

                        <li class="break-inside-avoid">
                            <div class="border p-4 rounded-md block">

                                <div class="flex gap-1 items-center">
                                    <div class="flex">
                                        <input type="checkbox" [value]="i.id" id="selected_comment_{{$index}}" hidden>
                                        <label for="selected_comment_{{$index}}"
                                            class="bg-zinc-100 px-4 font-semibold rounded-full text-zinc-500 py-2 text-xs">
                                            <i class="ri-star-fill"></i> <span>Highlight</span>
                                        </label>
                                    </div>
                                    <button type="button" (click)="removetestimonalAndComment(i.id,'commented_id')"
                                        class="btn btn-sm bg-red-100 text-red-500 btn-circle"><i
                                            class="ri-delete-bin-line"></i></button>
                                </div>

                                <div class="flex items-center gap-3 mt-2">
                                    <!-- <div class="avatar">
                                        <div class="w-8 h-8 rounded-full overflow-hidden">
                                            <img [src]="getCommentUserImage(i)" [alt]="getCommentUserName(i)" />
                                        </div>
                                    </div> -->
                                    <p class="text-xs text-zinc-500 font-medium">{{getCommentUserName(i)}}</p>
                                </div>
                                <p class="text-sm text-zinc-600 mt-2">
                                    {{i.comments}}
                                </p>
                            </div>
                        </li>


                        <!-- <li class="break-inside-avoid">
                            <input type="checkbox" [value]="i.id" id="comment_{{$index}}" hidden
                                class="card_highlight_checkBox" (change)="onCheckboxChange($event,'commented_id',i)"
                                [checked]="othersForm.get('commented_id')?.value.includes(i.id)" />
                            <label for="comment_{{$index}}" class="bg-zinc-100 p-4 rounded-md block cursor-pointer">
                                <p class="text-sm text-zinc-600">
                                    {{i.comments}}
                                </p>
                            </label>
                        </li> -->
                        }
                    </ul>
                </li>

                <li>
                    <hr class="my-3">
                </li>
            </ul>

            <div class="flex justify-end">
                <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                    @if (isreqSending) {
                    <i class="ri-loader-2-line animate-spin"></i>
                    }@else {
                    <span>Save</span>
                    }
                </button>
            </div>

        </form>

    </div>

</section>


<dialog #commonTestimonialAndCommentModal class="modal">
    <div class="modal-box min-w-max  p-0 relative">

        <div class="px-5 py-3 border-b flex justify-between items-center">
            <h4 class="font-bold capitalize">Choose {{modalType}}</h4>
            <div class="modal-action m-0">

                <button (click)="isModalAddFormOpen = true" type="button" class="btn btn-sm capitalize">
                    <i class="ri-add-line"></i> Add {{modalType}}
                </button>

                <button (click)="restForm()" type="button" class="btn btn-sm btn-circle text-green-600"><i
                        class="ri-check-line"></i>
                </button>
            </div>
        </div>

        <div class=" flex overflow-auto">

            <div class="p-5  w-[40rem] max-h-[30rem] ">

                <form class="flex gap-3 items-center" (submit)="$event.preventDefault()">
                    <select class="select select-sm select-bordered" #sortSelect (change)="applyModalSort(sortSelect.value)">
                        <option value="" disabled selected>Sort By</option>
                        <option value="name-asc">Ascending</option>
                        <option value="name-desc">Descending</option>
                        <!-- <option value="date-asc">Date Asc</option>
                        <option value="date-desc">Date Desc</option> -->
                    </select>

                    <input
                        type="text"
                        placeholder="search"
                        class="input input-sm input-bordered"
                        #modalSearchInput
                        (input)="modalSearchText = modalSearchInput?.value || ''" />
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyModalSearch(modalSearchText)" [disabled]="!modalSearchText.trim()">
                        Apply
                    </button>
                    <button type="button" class="btn btn-sm btn-outline" (click)="clearModalFilters(sortSelect, modalSearchInput)">
                        Clear
                    </button>
                </form>

                @if (modalType == 'testimonial') {
                <ul class="mt-3 columns-2 gap-4 space-y-4">

                    @if (filteredTestimonialList.length === 0) {
                    <li class="col-span-2 text-center text-sm text-zinc-500">No testimonials match your search.</li>
                    }

                    @for (i of filteredTestimonialList; track $index) {

                    <li class="break-inside-avoid">
                        <input type="checkbox" [value]="i.id" id="testimonial_{{$index}}" hidden
                            class="card_highlight_checkBox" (change)="onCheckboxChange($event,'testimonial_id',i)"
                            [checked]="isSelected('testimonial_id', i.id)" />
                        <label for="testimonial_{{$index}}" class="bg-zinc-100 p-4 rounded-md block cursor-pointer">


                            <div class="flex items-center gap-3 mb-2">
                                <div class="avatar">
                                    <div class="w-8 h-8 rounded-full overflow-hidden">
                                        <img [src]="getTestimonialUserImage(i)" [alt]="getTestimonialUserName(i)" />
                                    </div>
                                </div>
                                <p class="font-semibold">{{getTestimonialUserName(i)}}</p>
                            </div>
                            <p class="text-sm text-zinc-600 break-all">
                                {{i.testimonial}}
                            </p>

                            <button type="button" (click)="deleteTestimonial(i.id, $event)"
                                class="btn btn-sm text-red-600 mt-3 bg-white"><i
                                    class="ri-delete-bin-line"></i>Delete</button>

                        </label>
                    </li>
                    }



                </ul>
                }

                @else if (modalType == 'comment') {
                <ul class="mt-3 columns-2 gap-4 space-y-4">
                    @if (filteredCommentList.length === 0) {
                    <li class="col-span-2 text-center text-sm text-zinc-500">No comments match your search.</li>
                    }
                    @for (i of filteredCommentList; track $index) {

                    <li class="break-inside-avoid">
                        <input type="checkbox" [value]="i.id" id="modal_comment_{{$index}}" hidden
                            class="card_highlight_checkBox" (change)="onCheckboxChange($event,'commented_id',i)"
                            [checked]="isSelected('commented_id', i.id)" />
                        <label for="modal_comment_{{$index}}" class="bg-zinc-100 p-4 rounded-md block cursor-pointer">
                            <div class="flex items-center gap-3 mb-1">
                                <!-- <div class="avatar">
                                    <div class="w-8 h-8 rounded-full overflow-hidden">
                                        <img [src]="getCommentUserImage(i)" [alt]="getCommentUserName(i)" />
                                    </div>
                                </div> -->
                                <p class="text-xs text-zinc-500 font-medium">{{getCommentUserName(i)}}</p>
                            </div>
                            <p class="text-sm text-zinc-600">
                                {{i.comments}}
                            </p>
                            <button type="button" class="btn btn-sm text-red-600 mt-3 bg-white"
                                (click)="deleteComment(i.id, $event)"><i
                                    class="ri-delete-bin-line"></i>Delete</button>
                        </label>
                    </li>
                    }
                </ul>
                }

            </div>
            @if (isModalAddFormOpen) {
            <div class="p-5 border-l  w-[20rem] sticky top-0">

                @if (modalType == 'testimonial') {
                <form [formGroup]="testimonialForm" (ngSubmit)="saveTestimonial()">
                    <div class="">

                        <div class="flex flex-col gap-1 w-full justify-center items-center">
                            <div class="w-20 h-20 rounded-full overflow-hidden relative z-0"
                                [ngClass]="{'error': testimonialForm.get('user_photo')?.invalid && testimonialForm.get('user_photo')?.touched}">
                                <input type="file" accept="image/jpeg, image/png"
                                    class="opacity-0 absolute w-full h-full z-20 "
                                    (change)="setTestimonialProfile($event)" />
                                @if (testimonialProfileUrl && testimonialProfileUrl != null) {
                                <div class="group w-full h-full">
                                    <span
                                        class="opacity-0 bg-black/40 absolute w-full h-full group-hover:opacity-100 transition-all duration-150 flex justify-center items-center">
                                        <i class="ri-account-circle-fill text-xl text-white"></i>
                                    </span>
                                    <img class="w-full h-full object-cover" [src]="testimonialProfileUrl" alt="">
                                </div>
                                }@else{
                                <span class="w-full h-full flex justify-center items-center bg-slate-100"><i
                                        class="ri-account-circle-line text-xl text-black"></i></span>
                                }
                            </div>
                            <p class="text-sm text-zinc-600 mt-2 req">Upload Profile</p>
                            @if (testimonialForm.get('user_photo')?.invalid &&
                            testimonialForm.get('user_photo')?.touched) {
                            <span class="text-red-500 text-xs">Profile image is required</span>
                            }
                        </div>

                        <div>
                            <label class="form-control w-full ">
                                <div class="label">
                                    <span class="label-text req">Name</span>
                                </div>
                                <input
                                    [ngClass]="{'error': testimonialForm.get('user_name')?.errors && testimonialForm.get('user_name')?.touched}"
                                    type="text" placeholder="Type here" class="input input-bordered w-full "
                                    formControlName="user_name" />
                                @if (testimonialForm.get('user_name')?.errors &&
                                testimonialForm.get('user_name')?.touched) {
                                <span class="text-red-500 text-xs">
                                    @if (testimonialForm.get('user_name')?.errors?.['required']) {
                                    <span>Name is required</span>
                                    }
                                    @else if (testimonialForm.get('user_name')?.errors?.['testimonialNameMinLength']) {
                                    <span>Minimum: 2 characters</span>
                                    }
                                    @else if (testimonialForm.get('user_name')?.errors?.['testimonialNameMaxLength']) {
                                    <span>Maximum: 50 characters</span>
                                    }
                                    @else if (testimonialForm.get('user_name')?.errors?.['trim']) {
                                    <span>Trim leading and trailing spaces</span>
                                    }
                                    @else if (testimonialForm.get('user_name')?.errors?.['testimonialNameAllowedChars'] || testimonialForm.get('user_name')?.errors?.['testimonialNameAllowedChars']) {
                                    <span>Only alphabets and spaces are allowed</span>
                                    }
                                </span>
                                }

                            </label>
                        </div>

                        <div>
                            <label class="form-control w-full ">
                                <div class="label">
                                    <span class="label-text req">Testimonial</span>
                                </div>
                                <textarea
                                    [ngClass]="{'error': testimonialForm.get('testimonial')?.errors && testimonialForm.get('testimonial')?.touched}"
                                    name="" id="" class="textarea textarea-bordered w-full" rows="5"
                                    formControlName="testimonial"></textarea>
                                @if (testimonialForm.get('testimonial')?.errors &&
                                testimonialForm.get('testimonial')?.touched)
                                {
                                <span class="text-red-500 text-xs">
                                    @if (testimonialForm.get('testimonial')?.errors?.['required']) {
                                    <span>Testimonial is required</span>
                                    }
                                    @else if (testimonialForm.get('testimonial')?.errors?.['testimonialMinLength']) {
                                    <span>Testimonial must be between 2 and 500 characters.
</span>
                                    }
                                    @else if (testimonialForm.get('testimonial')?.errors?.['testimonialMaxLength']) {
                                    <span>Testimonial must be between 2 and 500 characters.
</span>
                                    }
                                    @else if (testimonialForm.get('testimonial')?.errors?.['testimonialAllowedChars']) {
                                    <span>Please enter a valid testimonial.</span>
                                    }
                                    @else if (testimonialForm.get('testimonial')?.errors?.['trim']) {
                                    <span>Trim leading and trailing spaces</span>
                                    }
                                </span>
                                }

                            </label>
                        </div>

                        <div class="flex justify-end gap-3 mt-3">
                            <button (click)="isModalAddFormOpen = false" type="button"
                                class="btn btn-sm capitalize">cancel</button>
                            <!-- <button type="button" class="btn btn-sm capitalize btn-outline">save & preview</button> -->
                            <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                                @if (isreqSending) {
                                <i class="ri-loader-2-line animate-spin"></i>
                                }@else {
                                <span>Save</span>
                                }
                            </button>
                        </div>
                    </div>
                </form>
                }@else if (modalType == 'comment') {
                <form [formGroup]="commentForm" (ngSubmit)="saveComment()">
                    <div>

                        <div>
                            <label class="form-control w-full ">
                                <div class="label">
                                    <span class="label-text">Select User</span>
                                </div>
                                <select
                                    [ngClass]="{'error': commentForm.get('user_id')?.invalid && commentForm.get('user_id')?.touched}"
                                    class="select select-bordered" formControlName="user_id">
                                    <option disabled selected>Pick one</option>
                                    @for (i of usersList; track $index) {
                                    <option value="{{i.id}}">{{i.name}}</option>
                                    }
                                </select>
                                @if (commentForm.get('user_id')?.invalid && commentForm.get('user_id')?.touched) {
                                <span class="text-red-500 text-xs">User is required</span>
                                }
                            </label>
                        </div>

                        <div>
                            <label class="form-control w-full ">
                                <div class="label">
                                    <span class="label-text">Comment</span>
                                </div>
                                <textarea
                                    [ngClass]="{'error': commentForm.get('comment')?.invalid && commentForm.get('comment')?.touched}"
                                    name="" id="" class="textarea textarea-bordered w-full" rows="5"
                                    formControlName="comment"></textarea>
                                @if (commentForm.get('comment')?.invalid && commentForm.get('comment')?.touched) {
                                <span class="text-red-500 text-xs">
                                    @if (commentForm.get('comment')?.errors?.['required']) {
                                    <span>Comment is required</span>
                                    }
                                    @else if (commentForm.get('comment')?.errors?.['commentMinLength']) {
                                    <span>Comment must be between 2 and 500 characters.
</span>
                                    }
                                    @else if (commentForm.get('comment')?.errors?.['commentMaxLength']) {
                                    <span>Comment must be between 2 and 500 characters.
</span>
                                    }
                                    @else if (commentForm.get('comment')?.errors?.['commentAllowedChars']) {
                                    <span>Please enter a valid comment.</span>
                                    }
                                    @else if (commentForm.get('comment')?.errors?.['trim']) {
                                    <span>Trim leading and trailing spaces</span>
                                    }
                                </span>
                                }

                            </label>
                        </div>

                    </div>
                    <div class="px-5 py-2  flex justify-end gap-3 mt-3">
                        <button (click)="isModalAddFormOpen = false" type="button"
                            class="btn btn-sm capitalize">cancel</button>
                        <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                            @if (isreqSending) {
                            <i class="ri-loader-2-line animate-spin"></i>
                            }@else {
                            <span>Save</span>
                            }
                        </button>
                    </div>
                </form>
                }
            </div>
            }

        </div>



        @if (pendingDelete) {
        <div class="absolute inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
            <div class="bg-white rounded-lg shadow-xl w-full max-w-md p-4">
                <h3 class="font-bold text-lg">Confirm Delete</h3>
                <p class="py-3 text-sm text-zinc-600">
                    Are you sure you want to delete this {{pendingDelete.type}}?
                </p>
                <div class="flex justify-end gap-2">
                    <button type="button" class="btn btn-sm" [disabled]="isreqSending" (click)="closeDeleteConfirm()">
                        Cancel
                    </button>
                    <button type="button" class="btn btn-sm bg-red-600 text-white border-red-600 hover:bg-red-700"
                        [disabled]="isreqSending" (click)="confirmDelete()">
                        @if (isreqSending) {
                        <i class="ri-loader-2-line animate-spin"></i>
                        } @else {
                        <span>Delete</span>
                        }
                    </button>
                </div>
            </div>
        </div>
        }
    </div>
</dialog>
